export default __webpack_public_path__ + "static/media/tick.c5873a4f.png";